<template>
  <nav class="mobile-bottom-nav">
    <RouterLink
      v-for="item in navItems"
      :key="item.path"
      :to="item.path"
      class="nav-item"
      :class="{ active: isActive(item.path) }"
    >
      <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
        <path :d="item.icon" />
      </svg>
      <span class="nav-label">{{ item.label }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
  name: 'MobileBottomNav',
  components: { RouterLink },
  data() {
    return {
      navItems: [
        {
          path: '/',
          label: 'Home',
          icon: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
        },
        {
          path: '/products',
          label: 'Products',
          icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z'
        }
      ]
    }
  },
  methods: {
    isActive(path) {
      if (path === '/') {
        return this.$route.path === '/'
      }
      return this.$route.path.startsWith(path)
    }
  }
}
</script>

<style scoped>
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.5rem 0;
  z-index: 100;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem;
  text-decoration: none;
  color: #6b7280;
  transition: color 0.2s;
  flex: 1;
  max-width: 80px;
}

.nav-item.active {
  color: #52CD36;
}

.nav-icon {
  width: 1.5rem;
  height: 1.5rem;
  fill: currentColor;
}

.nav-label {
  font-size: 0.625rem;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

@media (min-width: 1024px) {
  .mobile-bottom-nav {
    display: none;
  }
}
</style>

